import { useContext } from 'react'
import { SpriteContext } from './icon-sprite-provider'

export class SpriteContextError extends Error {
	constructor(message: string) {
		super(message)
		this.name = 'SpriteContextError'
	}
}

export function useIconSpriteHref(name: string) {
	const ctx = useContext(SpriteContext)
	if (!ctx)
		throw new SpriteContextError(
			'useIconSpriteHref must be used within IconSpriteProvider.',
		)
	return ctx.getHref(name)
}

export function useIconSize() {
	const ctx = useContext(SpriteContext)
	if (!ctx)
		throw new SpriteContextError(
			'useIconSize must be used within IconSpriteProvider.',
		)
	return ctx.size
}

export function useIconsFromSprite() {
	const ctx = useContext(SpriteContext)
	if (!ctx)
		throw new SpriteContextError(
			'useIconsFromSprite must be used within IconSpriteProvider.',
		)
	return ctx.getIcons()
}
